import React, { Component } from 'react'
import Graphics from './Graphics';

import './Tubes.scss'

class EmptyTubeStand extends Component {
    render() {
        return (
            <ul style={{pointerEvents: 'none', zIndex: 2}}>
                <li aria-label="Tube Stand"
                  id="TubeStand" tabIndex={0}
                  //className="dropTarget"
                >
                    <Graphics id={this.props.id} />
                    <p aria-hidden="true" className="label" style={{display:"none"}}>Tube Stand</p>
                </li>
            </ul>
        );
    }
}

export default EmptyTubeStand;
